import gql from 'graphql-tag';
import { EVENT_ACTIVITY_NOTE_FRAGMENT } from './fragments/eventActivityNote.fragment';

export const EVENT_ACTIVITY_NOTE = gql`
  query EventActivityNote($input: DealEventActivityNotesInput!) {
    dealActivity {
      result: dealEventActivityNotes(input: $input) {
        error
        success
        list {
          __typename
          ...DealEventActivityNoteFields
        }
      }
    }
  }
  ${EVENT_ACTIVITY_NOTE_FRAGMENT}
`;
